import axiosInstance from "./AxiosInstance";

export function getClientProfileList(data) {
  return axiosInstance.post(`/client-profile/list`, data);
}

export function deleteClientProfile(data) {
  return axiosInstance.post(`/client-profile/delete`, data);
}

export function createClientProfile(data) {
  return axiosInstance.post(`/client-profile/create`, data);
}

export function updateClientProfile(data) {
  return axiosInstance.post(`/client-profile/update`, data);
}

export function importClientProfile(data) {
  return axiosInstance.post(`/client-profile/import`, data);
}

export function exportClientProfile(data) {
  return axiosInstance.post(`/client-profile/export`, data);
}

export function getSerachClientProfile(data) {
  return axiosInstance.post(`/client-profile/serach`, data);
}

export function getSerachUserProfile(data) {
  return axiosInstance.post(`/users/search-list`, data);
}

export function createAssignResPart(data) {
  return axiosInstance.post(`/reserves/create`, data);
}

export function updateAssignResPart(data) {
  return axiosInstance.post(`/reserves/update`, data);
}
